import PresidiPrestazioniListPage from "./pages/PresidiPrestazioniListPage.vue";
import PresidiPrestazioniEditPage from "./pages/PresidiPrestazioniEditPage.vue";

export default {
  PresidiPrestazioniListPage,
  PresidiPrestazioniEditPage,
};
